<template>
  <div id="app">
    <AppHeader />
    <main class="main-content">
      <router-view/>
    </main>
    <AppFooter />
    <button v-show="showBackTop" class="back-to-top" @click="scrollToTop" aria-label="返回顶部">
      <span class="arrow">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 19V7"/>
          <path d="M5 12l7-7 7 7"/>
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  },
  data () {
    return {
      showBackTop: false
    }
  },
  methods: {
    toggleBackTop () {
      this.showBackTop = window.scrollY > 300
    },
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.toggleBackTop)
    this.toggleBackTop()
  },
  unmounted () {
    window.removeEventListener('scroll', this.toggleBackTop)
  }
}
</script>

<style lang="less">
* {
  box-sizing: border-box;
}

:root {
  --bg: #0b0f13;
  --surface: #12171d;
  --surface-2: #0f141a;
  --text: #c9d1d9;
  --muted: #9aa3ad;
  --accent: #22e58f;
  --accent-2: #00d2ff;
}

body {
  margin: 0;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: var(--text);
  background-color: var(--bg);
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  padding-top: 80px;
}

.back-to-top {
  position: fixed;
  right: 24px;
  bottom: 24px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-2) 100%);
  border: none;
  cursor: pointer;
  box-shadow: 0 12px 24px rgba(34, 229, 143, 0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s, background-position 0.2s;
  z-index: 9999;
  display: grid;
  place-items: center;
  background-size: 200% 100%;
}

.back-to-top:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 32px rgba(34, 229, 143, 0.35);
  background-position: 100% 0;
}

.back-to-top:active {
  transform: translateY(0);
  box-shadow: 0 8px 16px rgba(34, 229, 143, 0.2);
}

.back-to-top .arrow {
  width: 22px;
  height: 22px;
  color: #0b0f13;
  transition: transform 0.2s ease;
}

.back-to-top:hover .arrow {
  transform: translateY(-2px);
}

.back-to-top svg {
  width: 22px;
  height: 22px;
}

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  font-weight: 600;
}

p {
  margin: 0;
}
</style>
